<template>
    <div @click="reEmitClick()">
        <div class="analog-clock-container" :class="{ 'icon': iconMode, 'course-bar': courseBarColor }">
            <div class="analog-clock" :class="{ dark: !iconMode && darkMode }">
                <div class="analog-clock__face">
                    <span
                        v-for="n in 60"
                        :key="n"
                        class="analog-clock__notch"
                        :class="{ '-long': !(n % 5) }"
                        :style="{ transform: `rotate(${n * 6}deg)` }"
                    >
                    </span>
                </div>

                <span
                    v-if="!iconMode"
                    class="analog-clock__hand -seconds"
                    :style="seconds"
                ></span>
                <span
                    class="analog-clock__hand -minutes"
                    :style="minutes"
                ></span>
                <span class="analog-clock__hand -hours" :style="hours"></span>
            </div>
        </div>
        <template v-if="!iconMode">
            <!--            <div class="text-clock mt-2 d-flex">-->
            <!--                <div class="text-clock__col -meridiem">-->
            <!--                    {{ meridiem }}M-->
            <!--                </div>-->
            <!--            </div>-->
            <div v-if="timezone.length" class="mt-2">
                <div class="timezone-text">
                    {{ timezoneLabel ? timezoneLabel : timezone }}
                </div>
            </div>
            <div v-else class="mt-2">
                <div class="timezone-text">
                    {{ trans("messages.Local time") }}
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import moment from "moment-timezone/builds/moment-timezone-with-data.min";

export default {
    name: "WorldClock",
    props: {
        timezone: {
            type: String,
            default: "",
        },
        timezoneLabel: {
            type: String,
            default: "",
        },
        iconMode: {
            type: Boolean,
            default: false,
        },
        courseBarColor: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        rotation: { hours: 0, minutes: 0, seconds: 0 },
        hour: 0
    }),
    computed: {
        hours() {
            return {
                transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.hours}deg)`
            };
        },
        minutes() {
            return {
                transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.minutes}deg)`
            };
        },
        seconds() {
            return {
                transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.seconds}deg)`
            };
        },
        meridiem() {
            return this.hour < 12 ? "A" : "P";
        },
        darkMode() {
            return this.hour < 7 || this.hour > 19;
        }
    },
    methods: {
        updateTime() {
            let dateTime = null;
            if (this.timezone.length) {
                // console.log(this.timezone)
                dateTime = new Date(
                    moment()
                        .tz(this.timezone)
                        .format("YYYY-MM-DD HH:mm:ss")
                );
            } else {
                dateTime = new Date();
            }

            setTimeout(
                () => this.updateTime(),
                1000 - dateTime.getMilliseconds()
            );

            let [h, m, s] = [
                dateTime.getHours(),
                dateTime.getMinutes(),
                dateTime.getSeconds()
            ];
            this.hour = h;
            this.rotation = {
                hours: h * 30 + m * 0.5,
                minutes: m * 6 + s * 0.1,
                seconds: s * 6
            };
        },
        reEmitClick() {
            this.$emit("click");
        }
    },
    mounted() {
        this.updateTime();
    }
};
</script>

<style lang="scss" scoped>
@import "resources/sass/_variables.scss";

.analog-clock-container {
    min-width: 30px;
    min-height: 35px;
    width: 100%;
    position: relative;

    &::after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }
}

@media screen and (max-width: 767px) {
    .analog-clock-container {
        min-width: 30px;
        min-height: 31px;
        top: 0px;

        &::after {
            content: "";
            display: block;
            padding-bottom: 100%;
        }
    }
}

.analog-clock-container.icon {
    .analog-clock {
        &__notch {
            &::after {
                // background-color: #808080;
                background-color: $default-color;
            }
            &.-long::after {
                // background-color: #808080;
                background-color: $default-color;
                width: 2px;
                height: 17.5%;
            }
        }
        &__hand {
            // background-color: #808080;
            background-color: $default-color;
        }
    }
    &.course-bar {
        .analog-clock {
            &__notch {
                &::after {
                    // background-color: #808080;
                    background-color: $color-course-bar;
                }
                &.-long::after {
                    // background-color: #808080;
                    background-color: $color-course-bar;
                    width: 2px;
                    height: 17.5%;
                }
            }
            &__hand {
                // background-color: #808080;
                background-color: $color-course-bar;
            }
        }
    }

    &:hover {
        .analog-clock {
            &__notch {
                &::after {
                    background-color: $color-primary;
                }
                &.-long::after {
                    background-color: $color-primary;
                    width: 2px;
                    height: 17.5%;
                }
            }
            &__hand {
                background-color: $color-primary;
            }
        }
    }
}

.analog-clock {
    margin: 0 !important;
    width: 100%;
    height: 100%;
    top: 50%;
    position: absolute;
    border-radius: 100%;
    transform: translate3d(0, -50%, 1em);
    filter: drop-shadow(0 0.125rem 0.5rem rgba(black, 0.1));

    &.dark {
        background-color: gray;
        .analog-clock__notch {
            &::after {
                background-color: lightblue;
            }
            &.-long::after {
                background-color: white;
            }
        }
        .analog-clock__hand {
            background-color: white;
        }
    }

    &::after {
        top: 50%;
        left: 50%;
        content: "";
        width: 2.5%;
        height: 2.5%;
        position: absolute;
        border-radius: 100%;
        background-color: #edbec5;
        transform: translate3d(-50%, -50%, 0);
    }

    &__face {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__notch {
        transform-origin: 50% 100%;
        position: absolute;
        width: 1px;
        height: 49%;
        bottom: 50%;
        left: 50%;

        &::after {
            content: "";
            width: 100%;
            height: 2.5%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #b6c3c9;
        }

        &.-long::after {
            width: 2px;
            height: 7.5%;
        }
    }

    &__hand {
        transform-origin: 50% 100%;
        background-color: #7392a0;
        position: absolute;
        width: 2px;
        height: 40%;
        bottom: 50%;
        left: 50%;
        border-radius: 2px;
        //transition: transform 1s linear !important;

        &::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            height: 10%;
            background-color: inherit;
            backface-visibility: hidden;
        }

        &.-hours {
            height: calc(100% / 3);
            width: 3px;
            border-radius: 3px;
            //transition: transform 60s linear !important;
        }

        &.-seconds {
            width: 1px;
            height: 45%;
            border-radius: 0;
            background-color: #edbec5;
            //transition: transform 100ms cubic-bezier(.6, .05, 0, 1.6) !important;

            &::after {
                height: 12.5%;
            }
        }
    }
}
.timezone-text {
    //font-size: 0.8vw;
    text-align: center;
    width: 100%;
    word-break: break-word;
    white-space: normal;
}
</style>
